/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { allows } from '../../utils/authorization';
import modalTypes from '../../constants/modalTypes';
import { openModal } from '../../actions/modalActions';
import { removeTeamFromProduct } from '../../actions/productActions';
import { addTeam } from '../../actions/teamActions';

class TeamCard extends Component {
  openDetailTeamCard = () => {
    const { team } = this.props;
    const allowEdit = team.id ? allows('update', team) : true;
    const allowCreate = team.id ? allows('create', team) : true;
    const allowDelete = team.id ? allows('destroy', team) : true;
    const allowRestore = team.id ? allows('restore_teams', team) : true;
    const allowAddMembers = team.id ? allows('add_members_teams', team) : true;
    const allowUpdateRoles = team.id ? allows('add_role_teams', team) : true;

    this.props.addTeam(team);
    this.props.openModal(
      modalTypes.team,
      {
        id: team.id,
        allowEdit,
        allowCreate,
        allowDelete,
        allowRestore,
        allowAddMembers,
        allowUpdateRoles
      },
      'teamCard'
    );
  };

  removeTeam = () => {
    const { team, product, openModal } = this.props;

    const actions = {
      confirm: {
        name: 'Yes',
        function: () => {
          if (product.id) {
            this.props.removeTeamFromProduct(team.id, product.id);
          } else {
            this.props.removeTemporaryTeam(team.id);
          }
        }
      }
    };

    openModal(
      modalTypes.message,
      {
        message: `Are you sure you want to remove the team ${
          team.short_name
        } from ${product.short_name || 'this new team'}?`,
        actions,
        closeButtonTitle: 'No'
      },
      'confirm deletion'
    );
  };

  render() {
    const { team, allowDelete } = this.props;
    return (
      <div className="panel panel-default wall-row team-card">
        <div className="panel-heading">
          <div className="panel-title">
            <div className="col-sm-11 col-xs-11">
              <a onClick={this.openDetailTeamCard}>{team.short_name}</a>
            </div>
            <div className="col-sm-1 col-xs-1 close-button">
              <button
                onClick={this.removeTeam}
                title="Remove team from product"
                type="button"
                className="btn btn-link"
                disabled={!allowDelete}
              >
                &times;
              </button>
            </div>
          </div>
        </div>
        <div className="panel-body" />
      </div>
    );
  }
}

TeamCard.propTypes = {
  team: PropTypes.object.isRequired,
  product: PropTypes.object
};

TeamCard.defaultProps = {
  product: {}
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal,
      removeTeamFromProduct,
      addTeam
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(TeamCard);
